import { useEffect, useRef } from "react";

const API = process.env.REACT_APP_BACKEND_URL;

// Realtime Island events over WebSocket (cookie auth). Calls onEvent for each JSON event.
// Returns a send(obj) function for client → server events (e.g. typing).
export function useIslandSocket(onEvent) {
  const cb = useRef(onEvent);
  cb.current = onEvent;
  const wsRef = useRef(null);
  useEffect(() => {
    let alive = true; let timer; let ping;
    const connect = () => {
      let ws;
      try {
        ws = new WebSocket(API.replace(/^http/, "ws") + "/api/island/ws");
      } catch (e) { console.debug("WebSocket init failed", e); return; }
      wsRef.current = ws;
      ws.onmessage = (e) => { try { const ev = JSON.parse(e.data); if (ev.type !== "pong") cb.current?.(ev); } catch (err) { console.debug("Bad socket message", err); } };
      ws.onopen = () => { ping = setInterval(() => ws.readyState === 1 && ws.send("ping"), 25000); };
      ws.onclose = () => { clearInterval(ping); if (alive) timer = setTimeout(connect, 3000); };
      ws.onerror = () => ws.close();
    };
    connect();
    return () => { alive = false; clearTimeout(timer); clearInterval(ping); wsRef.current && wsRef.current.close(); };
  }, []);
  return (obj) => { const ws = wsRef.current; if (ws && ws.readyState === 1) ws.send(JSON.stringify(obj)); };
}

export function lastSeenLabel(p) {
  if (!p) return "";
  if (p.online) return "Online";
  if (!p.last_seen_at) return "Offline";
  const d = new Date(p.last_seen_at); const now = new Date();
  const t = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
  const sameDay = d.toDateString() === now.toDateString();
  const yest = new Date(now); yest.setDate(now.getDate() - 1);
  if (sameDay) return `Last seen today at ${t}`;
  if (d.toDateString() === yest.toDateString()) return `Last seen yesterday at ${t}`;
  return `Last seen ${d.toLocaleDateString([], { day: "numeric", month: "short" })} at ${t}`;
}
